import { useEffect } from 'react';
import { fetcher } from 'src/config/request/fetcher';
export function useConfigRequest(productId) {
    useEffect(function setProductIdToRequestHeader() {
        fetcher.defaults.headers.common['x-product-id'] = productId;
    }, [productId]);
}
